import script from "./ManualRefundList.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualRefundList.vue?vue&type=script&setup=true&lang=js"

import "./ManualRefundList.vue?vue&type=style&index=0&id=65364342&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65364342"]])

export default __exports__